import PropTypes from 'prop-types';
import { PasswordInput, Col, Row } from '@figure/frontlib-gui';
import * as Typography from 'shared/components/Typography';

const PasswordSectionForm = ({ values, errors, touched, setFieldValue }) => (
  <Row>
    <Col md={6}>
      <PasswordInput
        id="password1"
        label="Create password"
        name="password"
        data-test-id="password"
        value={values.password}
        errorText={touched.password && errors.password}
        onChange={(e) => setFieldValue('password', e.target.value)}
        required
      />
    </Col>

    <Col md={6}>
      <PasswordInput
        id="confirm-password"
        label="Confirm password"
        name="confirm-password"
        data-test-id="confirm-password"
        value={values.confirmPassword}
        errorText={touched.confirmPassword && errors.confirmPassword}
        onChange={(e) => setFieldValue('confirmPassword', e.target.value)}
        required
      />
    </Col>

    <Col>
      <Typography.SmallBodyGrey style={{ marginBottom: '15px' }} id="phone-number-description">
        Use a minimum of 9 characters. Comprised of at least one letter, number, and special character.
      </Typography.SmallBodyGrey>
    </Col>
  </Row>
);

PasswordSectionForm.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default PasswordSectionForm;
